import { render, staticRenderFns } from "./GenericChartWidget.vue?vue&type=template&id=fa45f3a2&scoped=true&"
import script from "./GenericChartWidget.vue?vue&type=script&lang=js&"
export * from "./GenericChartWidget.vue?vue&type=script&lang=js&"
import style0 from "./GenericChartWidget.vue?vue&type=style&index=0&id=fa45f3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa45f3a2",
  null
  
)

export default component.exports